<template>
  <b-modal v-model="showModal" :hide-footer="true" :hide-header="true" size="sm" :no-close-on-backdrop="true" id="message-modal" ref="message-modal" @hidden="resetModal">
    <b-col class="text-center pt-3" cols="12" v-if="message.text" v-html="message.text"></b-col>
    <b-col cols="12">
      <div class="text-center pt-3 pb-2">
        <b-button @click="handleClose">{{ 'ok' | lang }}</b-button>
      </div>
    </b-col>
  </b-modal>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "Message.vue",
  data() {
    return { showModal: false };
  },

  methods: {
    ...mapMutations(['setMessage']),

    resetModal() {
      this.setMessage({});
    },

    handleClose() {
      this.$root.$emit('bv::hide::modal', 'message-modal');

      if (this.message.callback) {
        this.message.callback();
      }
    },
  },

  computed: {
    ...mapState(['message']),
  },

  watch: {
    message(value) {
      this.showModal = !!Object.keys(value).length;
    },
  },

  created() {
    this.showModal = !!Object.keys(this.message).length;
  },
}
</script>